import React, { useState, useEffect, useReducer } from "react";
import { ChoosePaymentItemsSection } from "./ChoosePaymentItemsSection";
import { ChoosePaymentMethodSection } from "./ChoosePaymentMethodSection";
import { EnterCreditCardDetailsSection } from "./EnterCreditCardDetailsSection";
import logo from "../../logo.png"; // Tell Webpack this JS file uses this image
import { Constants } from "../../Constants";

const PaymentPage = (props) => {
  const [vehicleDetails, updateVehicleDetails] = useState([]); // [{vin:"",bookingNum:""}]
  const [containerDetails, updateContainerDetails] = useState([]); // [{ladingNum:"", bookingNum:""}]
  const [formSubmitting, updateFormSubmitting] = useState(false);
  const [submitButtonText, updateSubmitButtonText] = useState("Submit");
  const [paymentItemTypeSelected, updatePaymentItemTypeSelected] =
    useState(false);
  const [paymentItemType, updatePaymentItemType] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [paymentDetails, updatePaymentDetails] = useState({
    paymentAmount: 0.0,
    creditCardExpired: false,
  });

  const updatePaymentFromSection = (details) => updatePaymentDetails(details);

  const setFormSubmitting = () => {
    updateFormSubmitting(true);
    updateSubmitButtonText("Please wait...");
  };

  const customLineBreak = () => (
    <div className="row">
      <div className="col-12">
        <div
          className="border border-rounded"
          style={{
            height: "10px",
            backgroundImage: "linear-gradient(5deg, #8400ac 0%, #007580 100%)",
          }}
        ></div>
      </div>
    </div>
  );

  const getErrors = () => {
    var errorList = [];
    var parts = window.location.href.replace(
      /[?&]+([^=&]+)=([^&]*)/gi,
      function (m, key, value) {
        if (key === "error") {
          errorList.push(value);
        }
      }
    );
    return errorList;
  };

  if (!paymentMethod) {
    return (
      <div className="row justify-content-center">
        <div className="col-sm-12 col-md-8">
          {getErrors().map((error, index) => (
            <div key={index} className="alert alert-danger m-1">
              {Constants.errorsList[error]}
            </div>
          ))}
        </div>		
        <div className="col-sm-12 my-3 col-md-8">
			<em>Need help? You can review our video guide to filling out this form by clicking <a href="https://youtu.be/hzNVBGva_Cw" target="_blank" rel="noreferrer noopener">here</a></em>
		</div>
        <div className="col-sm-12 col-md-8 card border border-black m-2 p-2 z-depth-5">
          <div className="row justify-content-center">
            <div className="col-auto display-4 mb-3">
              <img
                src={logo}
                alt="Logo"
                style={{ width: "64px" }}
                className="my-auto"
              />
              Payment
              <img
                src={logo}
                alt="Logo"
                style={{ width: "64px" }}
                className="my-auto"
              />
              <hr />
            </div>
            <div className="col-12 my-2">
              <div className="row">
                <div className="col-auto mx-auto h5">
                  <strong>Select payment method</strong>
                </div>
                <div className="w-100"></div>
                <div className="col-auto mx-auto my-2">
                  <button
                    className="btn btn-success"
                    onClick={() => {
                      setPaymentMethod("creditCard");
                    }}
                  >
                    Credit Card
                  </button>
                </div>
                <div className="w-100"></div>
                <div className="col-auto mx-auto mt-3">
                  <button
                    className="btn btn-success"
                    onClick={() => {
                      // setPaymentMethod("ach");
                      window.open(
                        "https://heartlandpaymentservices.net/WebPayments/AngelicSolutionsSpotInc/bills"
                      );
                    }}
                  >
                    ACH (Electronic Check)
                  </button>
                </div>
                <div className="w-100"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  if (paymentMethod === "creditCard") {
    return (
      <form
        method="post"
        action="/Payment"
        onSubmit={() => setFormSubmitting()}
      >
        <div className="row justify-content-center">
          <div className="col-sm-12 col-md-8">
            {getErrors().map((error, index) => (
              <div key={index} className="alert alert-danger m-1">
                {Constants.errorsList[error]}
              </div>
            ))}
          </div>
		  <div className="col-sm-12 my-3 col-md-8">
			<em>Need help? You can review our video guide to filling out this form by clicking <a href="https://youtu.be/hzNVBGva_Cw" target="_blank" rel="noreferrer noopener">here</a></em>
		  </div>
          <div className="col-sm-12 col-md-8 card border border-black m-2 p-2 z-depth-5">
            <div className="row justify-content-center">
              <div className="col-auto display-4 mb-3">
                <img
                  src={logo}
                  alt="Logo"
                  style={{ width: "64px" }}
                  className="my-auto"
                />
                Payment
                <img
                  src={logo}
                  alt="Logo"
                  style={{ width: "64px" }}
                  className="my-auto"
                />
                <hr />
              </div>
              <div className="col-12 mt-2">
                <div className="row">
                  <div className="col-auto mx-auto h5">
                    <strong>Select payment items</strong>
                  </div>
                  <div className="w-100"></div>
                  <div className="col-auto mx-auto">
                    <div className="form-check form-check-inline my-2 ml-2">
                      <input
                        type="radio"
                        className="form-check-input"
                        id="Paying-For-Vehicle"
                        name="paymentItemType"
                        onClick={() => {
                          updatePaymentItemType("vehicle");
                          updatePaymentItemTypeSelected(true);
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="Paying-For-Vehicle"
                      >
                        Vehicles
                      </label>
                    </div>
                    <div className="form-check form-check-inline my-2 ml-2">
                      <input
                        type="radio"
                        className="form-check-input"
                        id="Paying-For-Container"
                        name="paymentItemType"
                        onClick={() => {
                          updatePaymentItemType("container");
                          updatePaymentItemTypeSelected(true);
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="Paying-For-Container"
                      >
                        Container
                      </label>
                    </div>
                    <div className="form-check form-check-inline my-2 ml-2">
                      <input
                        type="radio"
                        className="form-check-input"
                        id="Paying-For-Both"
                        name="paymentItemType"
                        onClick={() => {
                          updatePaymentItemType("both");
                          updatePaymentItemTypeSelected(true);
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="Paying-For-Both"
                      >
                        Vehicles and containers
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              {paymentItemTypeSelected && (
                <div className="col-12">
                  <ChoosePaymentItemsSection
                    maxVehicles={20}
                    maxContainers={10}
                    onVehicleUpdate={updateVehicleDetails}
                    onContainerUpdate={updateContainerDetails}
                    paymentItemType={paymentItemType}
                  />

                  <div className="row">
                    <div className="col-12">
                      <div
                        className="border rounded-pill"
                        style={{
                          height: "10px",
                          backgroundImage:
                            "linear-gradient(5deg, #8400ac 0%, #007580 100%)",
                        }}
                      ></div>
                    </div>
                  </div>
                  <ChoosePaymentMethodSection
                    onChange={updatePaymentFromSection}
                  />
                  <div className="row">
                    <div className="col-12">
                      <div
                        className="border rounded-pill"
                        style={{
                          height: "10px",
                          backgroundImage:
                            "linear-gradient(5deg, #8400ac 0%, #007580 100%)",
                        }}
                      ></div>
                    </div>
                  </div>

                  {/* Payment details */}
                  <div className="row mt-2">
                    <div className="col-12 mt-2">
                      <div className="row">
                        <div className="col-auto mb-3 mx-auto h5">
                          <strong>Payment summary</strong>
                          <br />
                        </div>
                      </div>
                      {vehicleDetails.length === 0 &&
                        containerDetails.length === 0 && (
                          <em>Please add at least one vehicle or container</em>
                        )}
                    </div>
                    <div
                      hidden={vehicleDetails.length === 0}
                      className="col-sm-12 col-md-6 col-lg-4"
                    >
                      <div className="card border border-muted p-2">
                        <strong> {vehicleDetails.length} Vehicle(s) </strong>
                        <ol>
                          {vehicleDetails.map((item, index) => (
                            <li key={index} className="mb-2">
                              <em>Vin:</em> <strong>{item.vin}</strong> <br />
                              <em>Booking Number:</em>{" "}
                              <strong>{item.bookingNum}</strong>
                            </li>
                          ))}
                        </ol>
                      </div>
                    </div>
                    <div
                      hidden={containerDetails.length === 0}
                      className="col-sm-12 col-md-6 col-lg-4"
                    >
                      <div className="card border border-muted p-2">
                        <strong>{containerDetails.length} Container(s) </strong>
                        <ol>
                          {containerDetails.map((item, index) => (
                            <li key={index} className="mb-2">
                              <em>Bill of lading Number:</em>{" "}
                              <strong>{item.ladingNum}</strong> <br />
                              <em>Booking Number:</em>{" "}
                              <strong>{item.bookingNum}</strong>
                            </li>
                          ))}
                        </ol>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-4 ml-auto mt-auto">
                      {/* We're Truncating the third decimal, we're bearing the extra cost */}
                      <div className="card border border-muted p-2">
                        {Number(paymentDetails.paymentAmount) != 0 && <div>Amount to be paid: ${Number(paymentDetails.paymentAmount).toFixed(2)}</div>}
                        {paymentDetails.paymentType == "creditCardPayment" && <div>Credit card fee: $
                                        {(Number(paymentDetails.paymentAmount)*Constants.creditCardFeeFraction).toFixed(3)
                                        .slice(0,-1)}</div>}
                        <strong>Total payment:</strong>
                        <h5>
                          ${Number(paymentDetails.paymentAmount).toFixed(2)}
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12 mb-3">
            <hr />
            <button
              type="submit"
              disabled={
                formSubmitting ||
                (vehicleDetails.length === 0 &&
                  containerDetails.length === 0) ||
                Number(paymentDetails.paymentAmount) <= 0
              }
              className="btn btn-primary btn-lg btn-block"
            >
              {submitButtonText}
            </button>
            <hr />
            <div className="alert alert-warning">
              <strong>Please note:</strong> Payments must cover the cost of
              every added Vehicle and/or container exactly, please verify the
              payment amount with your invoice before submission. We cannot
              release your shipment overseas if we do not receive the full
              payment owed
            </div>
          </div>
          <div className="col-12" style={{ minHeight: "25vh" }}></div>
        </div>
      </form>
    );
  }
};

export { PaymentPage };

// const getNotificationAlertFromId = (id) => {
//     switch (id){
//         case "1":
//             return {"message":"Payment submission successfull","type":"alert-success"};
//         case "2":
//             return {"message":"Address validation failed. Please make sure the billing address you entered matches the address your bank has on file for you card","type":"alert-danger"};
//         case "3":
//             return {"message":"CCV/CVV validation failed. Please make sure the CCV number you entered matches the CCV number on your card","type":"alert-danger"};
//         case "4":
//             return {"message":"The transaction was declined as the bank reported insufficient funds/credit to complete the transaction","type":"alert-danger"};
//         case "5":
//             return {"message":"The transaction was declined","type":"alert-danger"};
//         default:
//             return {"message": "Invalid Id"};
//     }
// }

// const notificationAlert = (props) =>
//     <p className={props.type + " alert alert-dismissible"}>
//         {props.message}
//         <button type="button" className="close" data-dismiss="alert">
//             &times;
//         </button>
//     </p>

// var notifications =[];
// useEffect(() => {
//     var IDs = [];
//     window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
//         if(key === "notificationID"){
//             IDs.push(value);
//         }
//     });
//     notifications = IDs.map((id,index) => {
//         var returnValue = getNotificationAlertFromId(id);
//         if(!(returnValue.message === "Invalid Id")){
//             return <notificationAlert key={index} type={returnValue.type} message={returnValue.message}/>
//         }
//     });
// });
/*
                        <div className="row justify-content-start">
                            <div className="col-12">
                                <hr />
                            </div>
                            <div className="col-auto">
                                <button type="button"className="btn btn-primary"
                                    onClick={() => updateVisibility([false,true,true])}>
                                    Back
                                </button>
                            </div>
                            <div className="col-auto ml-auto">
                                <button type="button" className="btn btn-primary ml-auto"
                                    disabled={nextButtonDisabled.paymentConfirmation}
                                    onClick={() => updateVisibility([true,true,false])}>
                                    Next
                                </button>
                            </div>
                        </div>*/
